import React from 'react';
import ForgetPassword from './forms/ForgetPassword';
import { AuthWrapper } from '../../../_uiComponents/common/AuthWrapper';

export function ForgetPasswordWrapper(props) {
    
    return (
        <>
            <AuthWrapper heading="Forget Password">
                {/* <p className='sba-foregt-password-text'>
                    If there is a user account associated with the email address you entered,
                    an email will be sent to you containing instructions on how to reset your 
                    password.
                </p> */}
                <ForgetPassword />
            </AuthWrapper>
        </>
    )
}

